import { REQUEST_STATUS_NAMES } from './request-status.constants';

export const installRequestConstants = {
  WORK_STATUS_TEXT: REQUEST_STATUS_NAMES.WORK,
  NEW_STATUS_TEXT: REQUEST_STATUS_NAMES.NEW,
  INEDIT_STATUS_TEXT: REQUEST_STATUS_NAMES.IN_EDIT,
  MISTAKE_STATUS_TEXT: REQUEST_STATUS_NAMES.MISTAKE,
  COMPLETED_STATUS_TEXT: REQUEST_STATUS_NAMES.COMPLETED,
  DONE_STATUS_TEXT: REQUEST_STATUS_NAMES.DONE,
  CANCELLED_STATUS_TEXT: REQUEST_STATUS_NAMES.CANCELLED,
  REJECTED_STATUS_TEXT: REQUEST_STATUS_NAMES.REJECTED,
  REQUESTRETURN_STATUS_TEXT: REQUEST_STATUS_NAMES.REQUEST_RETURN,

  OBRZ_APP_K_DL_ACT_PREFFIX: 'obrz_app_k_dl',
  OBRZ_APP_K_DKP_ACT_PREFFIX: 'obrz_app_k_dkp',
  OBRZ_APP_PTS_PSM_ACT_PREFFIX: 'obrz_app_pts_psm',
  OBRZ_REQUISITS_PREFFIX: 'obrz_rekvizit',

  PROTECT_CASE_PRODUCT_NAME: 'Чехол защитный антивандальный',
} as const;
